import { useSearchParams } from 'react-router-dom';

interface IArgs {
  param: string;
  value: number;
}
const useUpdateSearchParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const hashmap: any = {};
  searchParams.forEach((val, key) => {
    hashmap[key] = val;
  });

  const update = ({ param, value }: IArgs) => {
    setSearchParams({
      ...hashmap,
      [param]: value,
    });
  };
  return { update };
};

export default useUpdateSearchParams;
